import React, { Component, useState } from 'react';
import Utility from '../../Utility';
import SourceBar from './Viewer/SourceBar'
import ReactModal from 'react-modal';

import { ReactComponent as IconClose } from './HeaderIcons/close.svg';
import { ReactComponent as IconInfo } from './HeaderIcons/info.svg';

import './Header.css';

ReactModal.setAppElement('#root');

class Header extends Component {
	componentDidUpdate(prevProps) {
		if (this.props.data.recording.title !== prevProps.data.recording.title) {
			Utility.emit('player.resize');
		}
	}

	componentDidMount() {
		Utility.emit('player.resize');
	}

	setHtml = (text) => {
		return { __html: text.replace(/(?:\r\n|\r|\n)/g, "<br />") };
	}

	render() {
		if (this.props.data.recording === false) {
			return(
				<div className="Header content-header loading-or-error">
					<a className="content-header-btn content-header-site-btn" href="https://leccap.engin.umich.edu/leccap/" title="Return to main site">
						<span>CAEN Lecture Viewer</span>
					</a>
					<span className="content-header-recording-title">&nbsp;</span>

					<span className="clearfix"></span>
				</div>
			);
		}

		return (
			<div id="title-header" className="Header content-header">
				{ this.props.data.orgLogo &&
				<OrgLogo url={this.props.data.orgLogo} />
				}
				{ this.props.data.showSiteTitle &&
				<a className="content-header-btn content-header-site-btn" href={'/leccap/site/' + this.props.data.recording.sitekey} title="Return to site overview">
					<span>{this.props.data.recording.sitename}</span>
				</a>
				}
				{ this.props.data.recording.title &&
					<span className="content-header-recording-title" dangerouslySetInnerHTML={this.setHtml(this.props.data.recording.title)}></span>
				}

				{ this.props.data.recording.description !== '[No Description]' ? <InfoButton data={this.props.data} /> : null }

				<div className="secondary-controls">
					<SourceBar data={this.props.data} updatePlayerState={this.props.updatePlayerState} />
				</div>
				<div className="source-shade"></div>

				<span className="clearfix"></span>
			</div>
		);
	}
}

let InfoButton = (props) => {
	const [ showModal, setShowModal ] = useState(false);

	let handleShowModal = () => {
		setShowModal(true);
	}

	let handleCloseModal = () => {
		setShowModal(false);
	}

	let setHtml = (text) => {
		return { __html: text.replace(/(?:\r\n|\r|\n)/g, "<br />") };
	}

	return (<>
		<ReactModal
			isOpen={showModal}
			contentLabel="Recording Description"
			onRequestClose={handleCloseModal}
			shouldCloseOnEsc={true}
			shouldCloseOnOverlayClick={true}
			className="modal modal-description"
			overlayClassName="modal-overlay"
			>
				<button className="modal-close-button" onClick={handleCloseModal}>
					<IconClose />
				</button>

				<dl>
					<dt style={{ float: 'left' }}>Title:</dt>
					<dd dangerouslySetInnerHTML={setHtml(props.data.recording.title)}></dd>

					<dt>Description:</dt>
					<dd dangerouslySetInnerHTML={setHtml(props.data.recording.description)}></dd>
				</dl>
		</ReactModal>

		<button className="info-button" onClick={handleShowModal}>
			<IconInfo />
		</button>
	</>);
}

class OrgLogo extends React.PureComponent {
	render() {
		return(
			<span className="content-header-organization-logo">
				<img alt="logo" src={this.props.url} />
			</span>
		);
	}
}


export default Header;
